<script>
import VTaskForm from "@/components/Forms/VTaskForm";
import VTravelForm from "@/components/Forms/VTravelForm";
import VSystemActivityForm from "@/components/Forms/VSystemActivityForm";
import VDaylogForm from "@/components/Forms/VDaylogForm";
import { EventBus } from "@/libraries/EventBus";
import { mapGetters } from "vuex";
import dayjs from "dayjs";

export default {
    name: "VShortcuts",
    components: {
        VTaskForm,
        VTravelForm,
        VSystemActivityForm,
        VDaylogForm
    },
    data() {
        return {
            newVersion: false,
            showTaskModal: false,
            showHolidayModal: false,
            showExpensesModal: false,
            showTravelModal: false,
            showSystemActivityModal: false,
            showDaylogModal: false,
            daylogContext: null
        };
    },
    computed: {
        ...mapGetters("auth", ["getIsImpersonated", "getAuthUser"])
    },
    watch: {
        /**
         * Watch the route for changes and if possible
         * set "REgister time"
         */
        $route(to, from) {
            console.log("VShortcuts: ROUTE CHANGE", to.path, to.params);
        }
    },
    created() {
        EventBus.$on("new-system-version", this.newVersionAvailable);
        EventBus.$on("register-absence", this.openSystemActivityModal);
        EventBus.$on("register-daylog", this.openDaylogModal);
    },
    beforeDestroy() {
        EventBus.$off("new-system-version");
        EventBus.$off("register-absence");
        EventBus.$off("register-daylog");
    },
    methods: {
        newVersionAvailable() {
            this.newVersion = true;
        },
        reloadPage() {
            window.location.reload();
        },
        openTaskModal() {
            this.showTaskModal = true;
        },
        closeTaskModal() {
            this.showTaskModal = false;
        },
        taskSaved(task) {
            // DE does not want this functionality
            if (this.$isDK) {
                if (task.project_id) {
                    this.$router.push({
                        name: "ProjectDisplay",
                        params: { project_id: task.project_id }
                    });
                }
            }

            this.showTaskModal = false;
        },
        openTravelModal() {
            this.showTravelModal = true;
        },
        closeTravelModal() {
            this.showTravelModal = false;
        },
        travelSaved(travel) {
            this.showTravelModal = false;
        },
        /**
         * System activity modal: open
         */
        openSystemActivityModal() {
            this.showSystemActivityModal = true;
        },
        closeSystemActivityModal() {
            this.showSystemActivityModal = false;
        },
        saveSystemActivity(act) {
            this.showSystemActivityModal = false;
            EventBus.$emit("refresh-dashboard");
            EventBus.$emit("task-created");
        },
        openDaylogModal(date = null) {
            console.log("ARG DATE", date);
            if (date === null) {
                date = dayjs().format("YYYY-MM-DD");
            }
            this.daylogContext = date;
            this.showDaylogModal = true;
        },
        closeDaylogModal() {
            this.daylogContext = null;
            this.showDaylogModal = false;
        },
        openTiles() {
            EventBus.$emit("tiles-open");
        }
    }
};
</script>

<template>
    <div class="v-shortcuts">
        <div class="v-shortcuts__content">
            <div v-if="false" class="v-shortcuts__left">
                <base-button size="sm" :outline="true" type="primary"
                    ><i class="far fa-bell"></i
                ></base-button>
            </div>
            <div class="v-shortcuts__right">
                <template v-if="$isDK">
                    <a
                        class="btn btn-sm btn-default btn-outline-default"
                        href="https://de.meg.momentumgreenenergy.com/login"
                        target="_blank"
                        v-if="
                            'account_map' in getAuthUser &&
                                getAuthUser['account_map']['de'] == true
                        "
                        >{{ $t("system.login_to_de") }}
                    </a>
                </template>
                <template v-if="$isDE">
                    <a
                        class="btn btn-sm btn-default btn-outline-default"
                        href="https://dk.meg.momentumgreenenergy.com/login"
                        target="_blank"
                        v-if="
                            'account_map' in getAuthUser &&
                                getAuthUser['account_map']['dk'] == true
                        "
                        >{{ $t("system.login_to_dk") }}
                    </a>
                </template>
                <base-button
                    v-if="newVersion"
                    size="sm"
                    :outline="false"
                    type="danger"
                    @click="reloadPage"
                >
                    <i class="far fa-redo-alt"></i>
                    {{ $t("system.new_version_reload_btn") }}
                </base-button>
                <base-button
                    v-if="false"
                    size="sm"
                    :outline="true"
                    type="primary"
                    class="add-shortcut"
                >
                    <i class="far fa-plus"></i>
                </base-button>

                <base-button
                    v-if="$isDK"
                    size="sm"
                    :outline="true"
                    type="primary"
                    @click="openSystemActivityModal"
                >
                    <i class="far fa-user-slash"></i>
                    {{ $t("shortcut.absence") }}
                </base-button>

                <base-button
                    size="sm"
                    :outline="true"
                    type="primary"
                    v-if="false"
                >
                    <i class="far fa-receipt"></i>
                </base-button>

                <base-button
                    @click="openTravelModal"
                    size="sm"
                    :outline="true"
                    type="primary"
                >
                    <i class="far fa-car"></i> {{ $t("shortcut.travel") }}
                </base-button>

                <base-button
                    size="sm"
                    :outline="true"
                    type="primary"
                    @click="openTaskModal"
                >
                    <i class="far fa-clock"></i>
                    {{ $t("shortcut.register_time") }}
                </base-button>

                <base-button
                    v-if="$isDE"
                    size="sm"
                    :outline="true"
                    type="default"
                    @click="openDaylogModal(null)"
                >
                    <i class="far fa-stopwatch"></i>
                    {{ $t("daylogs.register_time_btn") }}
                </base-button>

                <base-button
                    v-if="$isDK"
                    size="sm"
                    :outline="true"
                    type="default"
                    @click="openTiles()"
                >
                    <i class="far fa-th"></i>
                    {{ $t("tiles.btn_open") }}
                </base-button>

                <a
                    v-if="getIsImpersonated"
                    class="btn btn-sm btn-default"
                    href="/v1/users/deimpersonate"
                >
                    <i class="far fa-arrow-left"></i>
                    {{ $t("shortcut.change_user_back") }}
                </a>
            </div>
        </div>
        <portal to="shortcut-modal">
            <v-system-activity-form
                v-if="showSystemActivityModal"
                :context="{ empty: true }"
                @close="closeSystemActivityModal"
                @save="saveSystemActivity"
            />
            <v-task-form
                v-if="showTaskModal"
                :context="{ empty: true }"
                @close="closeTaskModal"
                @save="taskSaved"
            />
            <v-travel-form
                v-if="showTravelModal"
                :context="{ empty: true }"
                :show-projects="true"
                @close="closeTravelModal"
                @close-refresh="travelSaved"
            />
            <v-daylog-form
                v-if="showDaylogModal"
                :date="daylogContext"
                @close="closeDaylogModal"
            />
        </portal>
    </div>
</template>

<style lang="scss">
.btn-german {
    background: linear-gradient(
        to bottom,
        #000 0%,
        #000 33.33%,
        #d00 33.33%,
        #d00 66.66%,
        #ffcc00 66.66%,
        #ffcc00 100%
    ) !important;
    border: none; /* Remove border if desired */
    color: #fff !important; /* Adjust text color for readability */
    font-weight: bold !important;
    padding: 0.5rem 1rem;
}
</style>
